//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback, useRef, useState } from 'react';
import { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
// import SimpleBar from 'simplebar-react';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import { HOMEPAGE_ABOUT, PATH_INTERNSHIP, HOMEPAGE_CONTACT, HOMEPAGE_EMPLOYERS, HOMEPAGE_FAQ, MESSAGE_MODE_CANCEL_PLAN_SUCCESSFUL } from '../common/constants';
// import useSimpleBarRef from '../common/hooks/useSimpleBarRef';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import TopNav from '../topNav/TopNav';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import Header from './subComponents/Header';
import AboutUs from './subComponents/AboutUs';
import ContactUs from './subComponents/ContactUs';
import Employers from './subComponents/Employers';
import Landing from './subComponents/Landing';
import Faq from './subComponents/Faq';
import CancelSuccessfulMessage from './subComponents/CancelSuccessfulMessage';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
    pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
    pageHeader: {
        maxHeight: '81px',
        // [theme.breakpoints.down('md')]: { maxHeight: '134px' }, // commented out because no more second row menu -el 20221022
        // [theme.breakpoints.down('sm')]: { maxHeight: '81px' },
    },
    // pageHeader: {},
    pageContent: {
        flex: 1,
        overflowY: 'auto',
        // overflowY: 'auto',
        // overflowX: 'hidden',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    jobCenterLeft: { height: '100%', paddingTop: '25px' },
    jobCenterRight: { height: '100%', overflowY: 'hidden', flexWrap: 'unset', paddingTop: '35px', minHeight: '600px' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getHomePageComponent = (homePageId, location) => {
    const messageMode = location?.state?.messageMode;
    console.log('pathe compo', homePageId);
    console.log('PATH_INTERNSHIP', PATH_INTERNSHIP);

    if (!_isNil(messageMode)) {
        switch (messageMode) {
            case MESSAGE_MODE_CANCEL_PLAN_SUCCESSFUL:
                return <CancelSuccessfulMessage />;
            default:
                return null;
        }
    } else {
        switch (homePageId) {
            case HOMEPAGE_ABOUT:
                return <AboutUs />;
            case HOMEPAGE_CONTACT:
                return <ContactUs />;
            case HOMEPAGE_EMPLOYERS:
                return <Employers />;
            case HOMEPAGE_FAQ:
                return <Faq />;
            default:
                return <Landing />;
        }
    }
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const HomeLayout = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);
    // const { homePageId } = useParams();
    const location = useLocation();
    // const { /* simpleBarRef: pageContentSimpleBarEl, */ scrollToTop: scrollToPageTop } = useSimpleBarRef();
    const pageContentRef = useRef();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { subPage: homePageId } = props;
    console.log('homePageId:', homePageId);

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [isRequestOpenCreateAccountDialog, setIsRequestOpenCreateAccountDialog] = useState();

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    // const contentWrapperEl = _get(pageContentSimpleBarEl, 'current.contentWrapperEl');
    // const contentEl = _get(pageContentSimpleBarEl, 'current.contentEl');

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const scrollToPageTop = useCallback(() => {
        if (pageContentRef?.current) pageContentRef.current.scrollTop = 0;
    }, [pageContentRef]);

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...context, scrollToPageTop, isRequestOpenCreateAccountDialog, setIsRequestOpenCreateAccountDialog }}>
            <Grid {...defns.pageContainer}>
                <Grid {...defns.pageHeader}>
                    <TopNav />
                </Grid>
                <Grid {...defns.pageContent} ref={pageContentRef}>
                    {/* <SimpleBar style={{ height: '100%', width: '100%', flex: 1, overflowX: 'hidden' }} ref={pageContentSimpleBarEl}> */}
                    <Grid {...defns.tempContainer}>{getHomePageComponent(homePageId, location)}</Grid>
                    {/* </SimpleBar> */}
                </Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default HomeLayout;
